import React from "react";
import { PagingModule } from "./PagingModule";
import { TableModule } from "./TableModule";
import { GenericDataAccess } from "../datacontrols/GenericDataAccess";

export class GenericListComponent extends React.Component {
    constructor(props) {
        super(props);
        this.logger = window.BaseLogger;
        //this.dataAccess = window.GenericDataAccess;
        this.dataAccess = new GenericDataAccess();

        this.metaData = null;
        this.pageIndex = 0;
        this.plantId = -1;
        this.pageSize = 20;
        this.jobNo = null;
        this.totalPageCount = 0;

        this.state = {
            items: new Array(),
            isFirst: true,
            isLast: true,
        };

        this.onDeleting = this.onDeleting.bind(this);
        this.onRowSelected = this.onRowSelected.bind(this);
        this.onPageSizeChanged = this.onPageSizeChanged.bind(this);
        this.onFirstClick = this.onFirstClick.bind(this);
        this.onPreviousClick = this.onPreviousClick.bind(this);
        this.onNextClick = this.onNextClick.bind(this);
        this.onLastClick = this.onLastClick.bind(this);
        this.onPdfClick = this.onPdfClick.bind(this);
        this.onCsvClick = this.onCsvClick.bind(this);
        this.loadList();
        this.confirmation = props.confirmation;
    }

    componentDidMount() {
        if (this.props.onInit) {
            this.props.onInit(this);
        }
    }

    onPageSizeChanged(pageSize) {
        this.pageSize = pageSize;
        this.pageIndex = 0;
        this.loadList();
    }

    onPdfClick() {
        var url = this.props.filter
            ? "/api/" + encodeURI(this.props.dataObject) + "?format=pdf&filter=" + encodeURI(this.props.filter)
            : "/api/" + encodeURI(this.props.dataObject) + "?format=pdf";

        window.location = url;
    }

    onCsvClick() {
        var url = this.props.filter
            ? "/api/" + encodeURI(this.props.dataObject) + "?format=csv&filter=" + encodeURI(this.props.filter)
            : "/api/" + encodeURI(this.props.dataObject) + "?format=csv";

        window.location = url;
    }

    refresh() {
        this.loadList();
    }

    loadList() {
        var self = this;
        this.dataAccess.getMetaData(this.props.dataObject, function (result) {
            console.log("debug:::genericListComponent", result);
            self.metaData = result;
            self.loadItems();
        });
    }

    loadItems() {
        var self = this;
        var filter = this.props.filter ? this.props.filter : null;
        this.dataAccess.getList(this.props.dataObject, this.pageSize, this.pageIndex, filter, function (result) {
            var page = result;
            self.totalPageCount = page.totalPageCount;
            self.setState({
                items: page.items,
                isFirst: page.isFirst,
                isLast: page.isLast,
            });
        });
    }

    onFirstClick() {
        this.pageIndex = 0;
        this.loadList();
    }

    onPreviousClick() {
        if (this.pageIndex > 0) {
            this.pageIndex--;
        }
        this.loadList();
    }

    onNextClick() {
        if (this.pageIndex < this.totalPageCount - 1) {
            this.pageIndex++;
        }
        this.loadList();
    }

    onLastClick() {
        this.pageIndex = this.totalPageCount - 1;
        this.loadList();
    }

    onRowSelected(item) {
        if (this.props.onRowSelected) {
            this.props.onRowSelected(item, this.props.dataObject);
        }
    }

    onDeleting(item) {
        var self = this;
        let itemToDelete = item;
        console.log("debug:::delete", item);
        self.confirmation
            .show({
                content: "The item will be deleted. Do you want to continue?",
                title: "Delete Item",
            })
            .then((response) => {
                console.log("debug:::deleted");
                self.dataAccess.deleteItem(self.props.dataObject, itemToDelete.id, function () {
                    self.loadList();
                    if (self.props.onDeleted) {
                        self.props.onDeleted(itemToDelete, self.props.dataObject);
                    }
                });
            });
        // Confirmation.show('Delete', 'The item will be deleted. Do you want to continue?',
        //     function ()
        //     {
        //         self.dataAccess.deleteItem(self.props.dataObject, item.id, function () {
        //             self.loadList();
        //             if (self.props.onDeleted) {
        //                 self.props.onDeleted(item, self.props.dataObject);
        //             }
        //         });
        //     }
        // );
    }

    render() {
        var self = this;
        return (
            <div className="generic-list-component">
                {this.state.items && this.state.items.length > 0 && (
                    <div>
                        <PagingModule
                            pageIndex={this.pageIndex}
                            totalPageCount={this.totalPageCount}
                            isFirst={this.state.isFirst}
                            isLast={this.state.isLast}
                            onFirstClick={this.onFirstClick}
                            onPreviousClick={this.onPreviousClick}
                            onNextClick={this.onNextClick}
                            onLastClick={this.onLastClick}
                            onPageSizeChanged={this.onPageSizeChanged}
                            onPdfClick={this.onPdfClick}
                            onCsvClick={this.onCsvClick}
                        />
                        <TableModule
                            metaData={this.metaData}
                            items={this.state.items}
                            onRowSelected={this.onRowSelected}
                            enableDelete={this.props.enableDelete}
                            onDeleting={this.onDeleting}
                        />
                    </div>
                )}
                {(!this.state.items || this.state.items.length == 0) && (
                    <div className="alert alert-info">No results</div>
                )}
            </div>
        );
    }
}
